import { useMemo } from 'react';
import { SxProps, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { ReactComponent as NoChatsIconLarge } from './icons/NoChatsIcon-L.svg';
import { ReactComponent as NoChatsIconMedium } from './icons/NoChatsIcon-M.svg';
import { ReactComponent as NoChatsIconSmall } from './icons/NoChatsIcon-S.svg';

const styles = {
  border: '1px solid #DFF2F5',
  flexGrow: 1,
  alignItems: 'center',
  backgroundColor: '#fff',
  marginTop: '24px',
  height: 'calc(100vh - 187px)',
  svg: {
    marginTop: '216px',
  },
} as SxProps;

type NoChatsPageProps = {
  size: 'mobile' | 'tablet' | 'desktop';
};

export const NoChatsPage: React.FC<NoChatsPageProps> = ({ size }) => {
  const renderPage = useMemo(() => {
    switch (size) {
      case 'mobile': {
        return (
          <>
            <NoChatsIconSmall />
            <Typography variant="body16Bold" lineHeight="24px" color="grey.700">
              No chats were found
            </Typography>
          </>
        );
      }
      case 'tablet': {
        return (
          <>
            <NoChatsIconMedium />
            <Typography variant="body18Bold" lineHeight="30px" color="grey.700">
              No chats were found
            </Typography>
          </>
        );
      }
      default: {
        return (
          <>
            <NoChatsIconLarge />
            <Typography variant="head20Bold" lineHeight="30px" color="grey.700">
              No chats were found
            </Typography>
          </>
        );
      }
    }
  }, [size]);
  return (
    <Stack
      sx={{
        ...styles,
        gap: size === 'desktop' ? '36px' : '24px',
      }}
    >
      {renderPage}
    </Stack>
  );
};
